export default __webpack_public_path__ + "static/media/RedMarker.e7c38d6b.svg";